"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("../../Icon/index"));
var _index2 = _interopRequireDefault(require("../../Label/index"));
var _ListItem = _interopRequireDefault(require("./ListItem.style"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let ListItem = (_dec = (0, _reactJss.default)(_ListItem.default), _dec(_class = class ListItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showNested: false
    };
    this.toggleNestedList = this.toggleNestedList.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    const {
      rootId,
      value,
      activeItem,
      onClick
    } = this.props;
    e.preventDefault();
    e.stopPropagation();
    if (activeItem === value) return;
    onClick({
      id: rootId,
      value,
      error: false
    });
  }
  toggleNestedList(e) {
    const {
      showNested
    } = this.state;
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      showNested: !showNested
    });
  }
  renderNestedList() {
    const {
      rootId,
      classes,
      children,
      activeItem,
      offset,
      onClick,
      dataTestId
    } = this.props;
    const {
      showNested
    } = this.state;
    const newOffset = offset + 24;
    const ch = _react.default.Children.map(children, (child, index) => {
      const childProps = {
        id: rootId,
        activeItem,
        offset: newOffset,
        onClick,
        dataTestId: child.props.dataTestId || (dataTestId ? `${dataTestId}-nested-${index}` : undefined)
      };
      return _react.default.cloneElement(child, childProps);
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.nested, {
        show: showNested
      })
    }, ch);
  }
  renderArrow(classes, children) {
    const {
      showNested
    } = this.state;
    if (!children) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.emptyArrow
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.arrow, {
        show: showNested
      }),
      onClick: this.toggleNestedList
    }, /*#__PURE__*/_react.default.createElement(_index.default, {
      type: "arrow",
      size: "small"
    }));
  }
  render() {
    const {
      classes,
      id,
      value,
      className,
      label,
      leftIcon,
      activeItem,
      offset,
      children,
      dataTestId
    } = this.props;
    const chClasses = (0, _clsx.default)(className, classes.listItem, {
      active: activeItem === value
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: chClasses,
      onClick: this.handleClick,
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.row,
      style: {
        paddingLeft: offset
      }
    }, this.renderArrow(classes, children), leftIcon ? /*#__PURE__*/_react.default.createElement(_index.default, {
      className: classes.leftIcon,
      type: leftIcon
    }) : null, (0, _react.isValidElement)(label) ? label : /*#__PURE__*/_react.default.createElement(_index2.default, {
      className: classes.label,
      value: label
    })), this.renderNestedList());
  }
}) || _class);
ListItem.defaultProps = {
  visibility: 'visible',
  error: false,
  onClick: () => {}
};
var _default = exports.default = ListItem;